export const ENUMS = {
  REACT_APP_STRAPI_BASE_URL: process.env.REACT_APP_STRAPI_BASE_URL,
};

export const TransactionProcessAlias = Object.freeze({
  DEFAULT_PURCHASE: 'default-purchase/release-1',
  DEFAULT_INQUIRY: 'default-inquiry/release-1',
  DEFAULT_BOOKING: 'default-booking/release-1',
});

export const UnitType = Object.freeze({
  ITEM: 'item',
  DAY: 'day',
  NIGHT: 'night',
  HOUR: 'hour',
  INQUIRY: 'inquiry',
});

export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const UserTypePreference = Object.freeze({
  PRIVATE_CHEFS: 'private-chefs',
  CUSTOMER: 'customer',
});

export const ListingStatusSection = Object.freeze({
  DRAFT: 'draft',
  AVAILABLE: 'available',
  SOLD: 'sold',
  CLOSED: 'closed',
});

export const ListingState = Object.freeze({
  DRAFT: 'draft',
  PUBLISHED: 'published',
  CLOSED: 'closed',
  SOLD: 'sold',
});

export const CropperShape = Object.freeze({
  RECTANGLE: 'rect',
  ROUND: 'round',
});

export const ProductType = Object.freeze({
  NEW: 'sell-new-products',
  USED: 'sell-used-products',
});

export const ProductConditionKey = Object.freeze({
  NEW_TAGS: 'newtags',
  WITHOUT_TAGS: 'withouttags',
  VERY_GOOD: 'vgood',
  GOOD: 'good',
  SATISFACTORY: 'satisfactory',
});

export const SliderSettings = Object.freeze({
  dots: false,
  arrows: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
      },
    },
  ],
});

export const FieldConfigKey = Object.freeze({
  BRAND_NAME: 'brandname',
  SIZE: 'size',
  SOLE_TYPE: 'soletype',
  PRODUCT_CONDITION: 'productcondition',
  ADULT_KID: 'adkid',
});

// Filter priority order
export const FilterPriorityOrder = Object.freeze({
  size: 1,
  brandname: 2,
  productcondition: 3,
  soletype: 4,
  model: 5,
});

export const ImageVariants = Object.freeze({
  DEFAULT: 'default',
  LISTING_CARD: 'listing-card',
});

export const DeliveryMethod = Object.freeze({
  PICKUP: 'pickup',
  SHIPPING: 'shipping',
});

export const ShippingPreference = Object.freeze({
  PLATFORM: 'platform',
  OWN: 'own',
});

export const CheckoutSteps = Object.freeze({
  SHIPPING: 'shipping',
  CARRIERS: 'carriers',
  PAYMENT: 'payment',
});

export const Transitions = Object.freeze({
  ACCEPT: 'transition/accept',
  RETURN_PRODUCT: 'transition/return-product',
  MARK_DELIVERED: 'transition/mark-delivered',
  MARK_RECEIVED: 'transition/mark-received',
  RETURN_PRODUCT: 'transition/return-product',
  RECEIVED_RETURNED_PRODUCT: 'transition/received-returned-product',
  REQUEST_PAYMENT: 'transition/request-payment',
  CONFIRM_PAYMENT: 'transition/confirm-payment',
});

export const BooleanEnum = Object.freeze({
  TRUE: true,
  FALSE: false,
});

export const OfferTransitions = Object.freeze({
  SEND_OFFER: 'transition/send-offer',
  EXPIRE_OFFER: 'transition/expire-offer',
  ACCEPT_OFFER: 'transition/accept-offer',
  DECLINE_OFFER: 'transition/decline-offer',
  COUNTER_OFFER: 'transition/counter-offer',
  ACCEPT_AFTER_COUNTER_1: 'transition/accept-after-counter-1',
  DECLINE_AFTER_COUNTER_1: 'transition/decline-after-counter-1',
  COUNTER_AFTER_COUNTER_1: 'transition/counter-after-counter-1',
  ACCEPT_AFTER_COUNTER_2: 'transition/accept-after-counter-2',
  DECLINE_AFTER_COUNTER_2: 'transition/decline-after-counter-2',
  COUNTER_AFTER_COUNTER_2: 'transition/counter-after-counter-2',
  ACCEPT_AFTER_COUNTER_3: 'transition/accept-after-counter-3',
  DECLINE_AFTER_COUNTER_3: 'transition/decline-after-counter-3',
  REQUEST_PAYMENT_AFTER_OFFER_ACCEPTED: 'transition/request-payment-after-offer-accepted',
});

export const OfferState = Object.freeze({
  INITIAL: 'initial',
  COUNTER: 'counter',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ALL: 'all',
});

export const DEFAULT_PACKAGE_DIMENSIONS = {
  height: '30',
  width: '20',
  length: '14',
  weight: '1.5',
  distanceUnit: { value: 'cm', label: 'Centimetres' },
  massUnit: { value: 'kg', label: 'Kilograms' },
};

export const UUID = 'UUID';
export const ACCEPT_IMAGES = ['image/png', 'image/jpeg', 'image/svg+xml'];

export const dietarySafetyTabFields = [];
export const removedProfileDataFields = [
  'extraTravelFeeRules',
  'dietaryOptions',
  'allergenHandlingText',
];
export const pricingOverviewTabFields = ['minGuests', 'maxGuests'];
export const professionalTabFields = ['primaryCuisine', 'specialties', 'languages'];
export const availabilityTabFields = ['noticeRequired'];

export const StaticPrimaryCuisine = [
  'Indian',
  'Italian',
  'Chinese',
  'Thai',
  'Mexican',
  'Japanese',
  'French',
  'Korean',
  'Mediterranean',
  'American',
  'Vietnamese',
];

export const StaticEventType = [
  'Birthday Party',
  'Wedding',
  'Corporate Event',
  'Anniversary',
  'Engagement',
  'Baby Shower',
  'House Party',
  'Festival',
  'Any',
];
